// src/features/insurancePlan/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { ServiceType } from '../../types/insurancePlanTypes';
import StatusTag from '../../../../common/components/Status';



const ServicePage = () => {


    // Define columns for the Service table
    const ServiceColumns: ColumnsType<ServiceType> = [
        { title: 'Name', dataIndex: "name", key: "name" },
        { title: 'NameAr', dataIndex: "nameAr", key: "nameAr" },
        {
            title: "Active",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive: boolean) => (
                <StatusTag status={isActive ? "Yes" : "No"} />
            ),
        },

    ];

    return (
        <div>
            <DynamicTable<ServiceType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.INSURANCEPLAN.SEARCH_SERVICETYPE} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.INSURANCEPLAN.SERVICETYPES} // Unique query key for menus
                columns={ServiceColumns}
                tableTitle={"Service Types"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.INSURANCEPLAN.DELETE_SERVICETYPE}
                deletePayloadField={"name"}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "Search by name" },

                ]}
            />
        </div>
    );
};

export default ServicePage;